import React from "react";

const Color: React.FC = () => {
  return (
    <div className="pointer-events-none fixed inset-0 z-40 h-full w-full bg-gradient-to-t from-bg-dark to-transparent p-1 opacity-40" />
  );
};

export default Color;
